import {groupAccessLocations} from '@/modules/locations/functions'
import {UserFormSchema} from '@/modules/users/schemas'
import {User} from '@cypro/engine/schema'
import {getAddressFieldsDefaultValues, type Address} from '@cypro/ui/components/form/address/utils'
import {SelectItem} from '@cypro/ui/components/form/select'

export function getDefaultUserFormValues(user: User | undefined, defaultAddress?: Partial<Address>): UserFormSchema {
  const sections: UserFormSchema['sections'] = []
  const groups: string[] = user?.groups?.map(g => g.id) || []

  if (user?.userAccessLocations) {
    const groupedAccessLocations = groupAccessLocations(user.userAccessLocations)
    groupedAccessLocations.forEach(location => {
      location.sections.forEach(section => {
        sections.push({
          id: section.id,
          name: section.name,
          locationId: location.id,
          wards: section.wards.map(w => w.id),
        })
      })
    })
  }

  return {
    id: user?.id,
    username: user?.username || '',
    firstName: user?.firstName || '',
    lastName: user?.lastName || '',
    tempPassword: '',
    groups,
    email: user?.email || '',
    sections,
    title: user?.title || '',
    hospitalSystemId: user?.hospitalSystemId || '',
    nationalPhysicianNumber: user?.nationalPhysicianNumber || '',
    hospitalPhysicianNumber: user?.hospitalPhysicianNumber || '',
    isActiveOnCypro: user?.isActiveOnCypro ?? true,
    address: getAddressFieldsDefaultValues(user?.address, defaultAddress),
  }
}

export type UserNameFormat = 'first-last' | 'last-first'

export function getFullName(user: User | undefined | null, format: UserNameFormat = 'first-last') {
  if (!user) return ''

  const nameParts = format === 'first-last' ? [user.firstName, user.lastName] : [user.lastName, user.firstName]
  const name = nameParts.filter(Boolean).join(' ')

  // the user's title (e.g. "Dr") goes in front of the full name wherever it is displayed
  return user.title ? `${user.title.trim()} ${name}`.trim() : name
}

export function mapUsersToSelectItems(users: User[] = []): SelectItem[] {
  return users.map(user => ({...user, label: getFullName(user, 'last-first'), value: user.id}))
}
